import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import NumberFormat from 'react-number-format';
import { ThemeShape, Default } from '../theme/InputText';

const StyledInputText = styled.span`
  display: inline-block;
  font-weight: 500 !important;
  margin-right: 0.3em;

  ${({ width }) => width && `width: ${width}rem`};

  input {
    font-size: 1rem;
    font-weight: 500 !important;

    border: none;
    ${({ theme }) => theme.container}

    ::-webkit-input-placeholder {
      ${({ theme }) => theme.placeholder}
    }
    ::-moz-placeholder {
      ${({ theme }) => theme.placeholder}
    }
    ::-ms-placeholder {
      ${({ theme }) => theme.placeholder}
    }
    ::placeholder {
      ${({ theme }) => theme.placeholder}
    }
  }

  ${({ dissapear }) =>
    dissapear &&
    `
      width: 0px;
      margin: 0px;
  `}

  ${({ positionAbsolute }) =>
    positionAbsolute &&
    `
      position: absolute;
      z-index: -10;
  `}
`;

const StyledInput = styled.input`
  ${({ width }) => width && `width: ${width}`};
`;

const InputText = ({
  value,
  name,
  dissapear,
  positionAbsolute,
  onChange,
  onBlur,
  theme,
  isCurrency,
  pattern,
  width,
  inputSpanWidth,
  inputWidth,
  placeholder,
  prepend,
  postpend,
  isTextual,
  noThousandSeparator,
  ...rest
}) => {
  let Input = isCurrency ? NumberFormat : StyledInput;
  if (isTextual) Input = StyledInput;
  return (
    <ThemeProvider theme={theme}>
      <StyledInputText
        width={inputSpanWidth}
        dissapear={dissapear}
        positionAbsolute={positionAbsolute}
      >
        {prepend}
        <Input
          type={isTextual ? 'text' : 'tel'}
          pattern={pattern}
          value={value}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          thousandSeparator={noThousandSeparator ? null : true}
          width={inputWidth}
          {...rest}
        />
        {postpend}
      </StyledInputText>
    </ThemeProvider>
  );
};

InputText.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pattern: PropTypes.string,
  noThousandSeparator: PropTypes.bool,
  isTextual: PropTypes.bool,
  name: PropTypes.string,
  width: PropTypes.number,
  inputWidth: PropTypes.string,
  inputSpanWidth: PropTypes.number,
  placeholder: PropTypes.string,
  prepend: PropTypes.string,
  postpend: PropTypes.string,
  isCurrency: PropTypes.bool,
  dissapear: PropTypes.bool,
  positionAbsolute: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  theme: ThemeShape,
};

InputText.defaultProps = {
  pattern: '',
  noThousandSeparator: null,
  isTextual: false,
  value: '',
  name: '',
  width: 0,
  inputWidth: null,
  inputSpanWidth: null,
  placeholder: 'inputText',
  prepend: '',
  postpend: '',
  isCurrency: false,
  onChange: () => {},
  onBlur: () => {},
  theme: Default,
  dissapear: false,
  positionAbsolute: false,
};

export default InputText;
